import React from 'react';
import { Row, Col } from 'antd';
import resources from '../../resources';
import languages from '../../appdata/languages';
import StoreManager from '../../appdata';
const imageStyle = {
  width: '100%',
  borderRadius: 8,
  objectFit: 'contain',
};

class VNGPeopleStrategyContent extends React.Component {
  render() {
    
    const lg = StoreManager.appState.thisApp.state.currentLanguage;
    const lang = languages[lg].VNGPeopleStrategyContent; // có thể dùng dynamic switch
    const {isMobile} = StoreManager.appState.thisApp.state


    return (
      <div style={{ lineHeight: 1.6, fontSize: 16 }}>
        <h2 style={{  fontFamily: 'Inter28-SemiBold', fontSize: isMobile ? 24 : 36, fontWeight: 600 }}>{lang.title}</h2>

        <div style={{ marginTop: 24 }}>
          {lang.introParagraphs.map((p, idx) => <p key={idx}>{p}</p>)}
        </div>
        <div style={{ marginTop: 24 }}>
            <img src={resources.images.VNGPeopleStrategyImage5} alt="VNGPeopleStrategyImage5" style={{...imageStyle, width: '100%', maxWidth: 800 }} />
          </div>

        <div style={{ marginTop: 48 }}>
          <h4 style={{ fontSize: 24, fontWeight: 600 }}>{lang.talentStrategyTitle}</h4>
          <Row gutter={[24, 24]} style={{ marginTop: 24, marginBottom: 24 }}>
            {/* {[lang.hiresStat, lang.referralStat].map((stat, i) => (
              
            ))} */}
            <Col xs={24} md={12}>
                <div style={{ backgroundColor: '#EDF8FF', borderRadius: 16, padding: 12,paddingLeft: 16,  display: 'flex', alignItems: 'center' }}>
                  <img src={resources.icons[lang.hiresStat.icon]} alt="icon" style={{ width: 40, height: 40, marginRight: 16 }} />
                  <div>
                    <div style={{ fontSize: 36, fontWeight: 600, color: '#F15A24', lineHeight: 1.1 }}>{lang.hiresStat.value}</div>
                    <div style={{ fontSize: 16, fontWeight: 500, fontFamily:'Inter28-SemiBold' }}>{lang.hiresStat.title}</div>
                    <div style={{ fontSize: 14, color: '#212121' }}>{lang.hiresStat.subtitle}</div>
                  </div>
                </div>
              </Col>
              <Col xs={24} md={12}>
                <div style={{ backgroundColor: '#EDF8FF', borderRadius: 16, padding: 12,paddingLeft: 16,  display: 'flex', alignItems: 'center' }}>
                  <img src={resources.icons[lang.referralStat.icon]} alt="icon" style={{ width: 40, height: 40, marginRight: 16 }} />
                  <div>
                  <div style={{ fontSize: 16, fontWeight: 500, fontFamily:'Inter28-SemiBold' }}>{lang.referralStat.title}</div>

                    <div style={{ fontSize: 36, fontWeight: 600, color: '#F15A24', lineHeight: 1.1 }}>{lang.referralStat.value}</div>
                    <div style={{ fontSize: 16, fontWeight: 500, fontFamily:'Inter28-SemiBold' }}>{lang.referralStat.subtitle}</div>
                  </div>
                </div>
              </Col>
          </Row>
          {lang.recruitmentParagraphs.map((p, idx) => <p key={idx}>{p}</p>)}
        </div>

        <div style={{ marginTop: 48 }}>
          <h4 style={{ fontSize: 24, fontWeight: 600 }}>{lang.benefitsTitle}</h4>
          {lang.benefitsParagraphs.map((p, idx) => <p key={idx}>{p}</p>)}

          {Object.values(lang.benefits).map((section, idx) => (
            <div key={idx}>
              <p style={{ marginTop: 20, fontWeight: 600 }}>{section.title}</p>
              <div style={{ backgroundColor: '#EDF8FF', borderRadius: 12, padding: 5, paddingLeft: 12, paddingRight: 12}}>
                <ul style={{ paddingLeft: 20 }}>
                  {section.items.map((item, i) => <li key={i}>{item}</li>)}
                </ul>
              </div>
            </div>
          ))}

          <p style={{ marginTop: 24 }}>{lang.dataProtection}</p>
          <p>{lang.communicationParagraph}</p>
        </div>

        <div style={{ marginTop: 48 }}>
          <p style={{ fontWeight: 600 }}>{lang.communicationChecklist.title}</p>
          <div style={{ backgroundColor: '#EDF8FF', borderRadius: 12, padding: 5, paddingLeft: 12, paddingRight: 12}}>
          <ul style={{ paddingLeft: 20  }}>
              {lang.communicationChecklist.items.map((item, idx) => <li key={idx}>{item}</li>)}
            </ul>
          </div>

          {lang.learningParagraphs.map((p, idx) => <p key={idx}>{p}</p>)}

        <Row gutter={[24, 24]} style={{ marginTop: 24, marginBottom: 48 }}>
            {lang.learningStats.map((item, idx) => (

              <Col xs={24} md={8} key={idx}>
              <div style={{
                backgroundColor: '#EDF8FF',
                borderRadius: 16,
                padding: 16,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'left',
                height: 'calc(100% - 32px)',  // trừ đi padding

              }}>
                <img src={resources.icons[item.icon]} alt="icon" style={{ width: 50, height: 50, marginBottom: 12 }} />
                <div style={{ fontWeight: 600, color: '#F15A24', fontSize: 28, marginBottom: 4 }}>{item.value}</div>
                <div style={{ fontWeight: 600, fontFamily:'Inter28-SemiBold' , fontSize: 16, textAlign: 'left' }}>{item.label}</div>
              </div>
              </Col>

              // <div key={idx} style={{ backgroundColor: '#EDF8FF', borderRadius: 16, padding: 24, minWidth: 200, flex: 1, display: 'flex', alignItems: 'center' }}>
              //   <img src={resources.icons[item.icon]} alt="icon" style={{ width: 32, height: 32, marginRight: 16 }} />
              //   <div>
              //     <div style={{ fontSize: 36, fontWeight: 600, color: '#F15A24' }}>{item.value}</div>
              //     <div style={{fontSize: 16, whiteSpace: 'pre-line' }}>{item.label}</div>
              //   </div>
              // </div>
            ))}
          </Row>
        </div>

        {/* Comprehensive Digital HR Transformation */}
        <div style={{ marginTop: 48 }}>
          <h4 style={{ fontSize: 24, fontWeight: 600 }}>{lang.digitalHRTitle}</h4>
          {lang.digitalHRParagraphs.map((p, idx) => <p key={idx}>{p}</p>)}
        </div>

        <div style={{ marginTop: 48 }}>
          <h4 style={{ fontSize: 24, fontWeight: 600 }}>{lang.workplaceTitle}</h4>
          {lang.workplaceParagraphs.slice(0, 2).map((p, idx) => <p key={idx}>{p}</p>)}
          <p style={{ fontWeight: 600 }}>{lang.workplaceParagraphs[2]}</p>
          <div style={{ marginTop: 24 }}>
            <img src={lg == 'vi'? resources.images.VNGPeopleStrategyImage1_vi :resources.images.VNGPeopleStrategyImage1} alt="Workforce Structure" style={{ width: '100%', maxWidth: 800 }} />
            <div style={{ display: 'flex', gap: 16, marginTop: 10 }}>
                  <img
                    src={ lg == 'vi'? resources.images.VNGPeopleStrategyImage6_vi : resources.images.VNGPeopleStrategyImage6}
                    alt={`- 2`}
                    style={{ ...imageStyle, width: 'calc(50% - 8px)' }}
                    />
                  <img
                    src={lg == 'vi'? resources.images.VNGPeopleStrategyImage7_vi : resources.images.VNGPeopleStrategyImage7}
                    alt={` - 3`}
                    style={{ ...imageStyle, width: 'calc(50% - 8px)' }}
                    />
          </div>
          </div>
        </div>

        <div style={{ marginTop: 48 }}>
          <h4 style={{ fontSize: 24, fontWeight: 600 }}>{lang.brandTitle}</h4>
          <p>{lang.brandParagraph}</p>

          <p style={{ fontWeight: 600, marginTop: 24 }}>Talent Engagement</p>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 16 }}>
            {lang.brandStats.engagement.map((item, idx) => (
              <div key={idx} style={{ backgroundColor: '#EDF8FF', borderRadius: 16, padding: 12, minWidth: 200, flex: 1, textAlign: 'center' }}>
                <div style={{ fontSize: 36, fontWeight: 600, color: '#F15A24' }}>{item.number}</div>
                <div style={{fontFamily:'Inter28-SemiBold' ,fontSize: 16}}>{item.label}</div>
              </div>
            ))}
          </div>

          <p style={{ fontWeight: 600, marginTop: 32 }}>Code Tour (year 5)</p>
          <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap' }}>
            {lang.brandStats.codeTour.map((item, idx) => (
              <div key={idx} style={{ backgroundColor: '#EDF8FF', borderRadius: 16, padding: 12, minWidth: 200, flex: 1, textAlign: 'center' }}>
                <div style={{ fontSize: 36, fontWeight: 600, color: '#F15A24' }}>{item.number}</div>
                <div  style={{fontFamily:'Inter28-SemiBold' , fontSize: 16,}}>{item.label}</div>
              </div>
            ))}
          </div>

          <p style={{ fontWeight: 600, marginTop: 32 }}>Career Fairs</p>
          <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap' }}>
            {lang.brandStats.careerFair.map((item, idx) => (
              <div key={idx} style={{ backgroundColor: '#EDF8FF', borderRadius: 16, padding: 12, minWidth: 200, flex: 1, textAlign: 'center' }}>
                <div style={{ fontSize: 36, fontWeight: 600, color: '#F15A24' }}>{item.number}</div>
                <div  style={{fontFamily:'Inter28-SemiBold' , fontSize: 16,}}>{item.label}</div>
              </div>
            ))}
          </div>

          <p style={{ fontWeight: 600, marginTop: 32 }}>VNG University Week</p>
          <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap' }}>
            {lang.brandStats.universityWeek.map((item, idx) => (
              <div key={idx} style={{ backgroundColor: '#EDF8FF', borderRadius: 16, padding: 12, minWidth: 200, flex: 1, textAlign: 'center' }}>
                <div style={{ fontSize: 36, fontWeight: 600, color: '#F15A24' }}>{item.number}</div>
                <div  style={{fontFamily:'Inter28-SemiBold' , fontSize: 16,}}>{item.label}</div>
              </div>
            ))}
          </div>
        </div>

        <div style={{ marginTop: 48 }}>
          <h4 style={{ fontSize: 24, fontWeight: 600 }}>{lang.engagementTitle}</h4>
          <p style={{ fontWeight: 600, marginTop: 16 }}>{lang.engagementStorytelling.title}</p>
          <div style={{ backgroundColor: '#EDF8FF', borderRadius: 16, padding: 24, display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: 24 }}>
            {lang.engagementStorytelling.stats.map((item, idx) => (
              <div key={idx} style={{ textAlign: 'center', flex: 1 }}>
                <div  style={{fontFamily:'Inter28-SemiBold' , fontSize: 16,}}>{item.label}</div>
                <div style={{ fontSize: 36, fontWeight: 600, color: '#F15A24' }}>{item.number}</div>
                <div style={{fontFamily:'Inter28-SemiBold'  }}>{item.unit}</div>
              </div>
            ))}
            <div style={{ flex: 2, display: 'flex', alignItems: 'center' }}>
              <p style={{ margin: 0 }}>{lang.engagementStorytelling.note}</p>
            </div>
          </div>

          <p style={{ fontWeight: 600, marginTop: 32 }}>{lang.wellnessTitle}</p>
          <div style={{ backgroundColor: '#EDF8FF', borderRadius: 12, padding: 5, paddingLeft: 12, paddingRight: 12}}>
            <ul style={{ paddingLeft: 20 }}>
              {lang.wellnessItems.map((item, idx) => <li key={idx}>{item}</li>)}
            </ul>
          </div>
        </div>

        <div style={{ marginTop: 48 }}>
          <h4 style={{ fontSize: 24, fontWeight: 600 }}>{lang.communicationTitle}</h4>
          {lang.communicationContent.map((p, idx) => <p key={idx}>{p}</p>)}

          <img
            src={lg == 'vi'? resources.images.VNGPeopleStrategyImage2_vi :resources.images.VNGPeopleStrategyImage2}
            alt="Social followers"
            style={{ width: '100%', margin: '24px 0', borderRadius: 0, objectFit: 'contain' }}
          />
        </div>

        {/* Conclusion */}
        <div style={{ marginTop: 48 }}>
          <h4 style={{ fontSize: 24, fontWeight: 600 }}>{lang.conclusionTitle}</h4>
          {lang.conclusionParagraphs.map((p, idx) => <p key={idx}>{p}</p>)}
        </div>
        <div style={{ display: 'flex', gap: 16 }}>
                  <img
                    src={resources.images.VNGPeopleStrategyImage3}
                    alt={`- 2`}
                    style={{ ...imageStyle, width: 'calc(50% - 8px)' }}
                    />
                  <img
                    src={resources.images.VNGPeopleStrategyImage4}
                    alt={` - 3`}
                    style={{ ...imageStyle, width: 'calc(50% - 8px)' }}
                    />
          </div>


      </div>
    );
  }
}

export default VNGPeopleStrategyContent;
